const Backbone = require('backbone');
const _ = require('underscore');
const moment = require('moment');

let interval;
const TimeModel = Backbone.Model.extend({
  mutators: {
    firstDay() {
      const day = moment(this.get('currentDate')).weekday(0);
      return day.add(this.get('currentWeek'), 'weeks');
    },
    secondDay() {
      const day = moment(this.get('currentDate')).weekday(1);
      return day.add(this.get('currentWeek'), 'weeks');
    },
    thirdDay() {
      const day = moment(this.get('currentDate')).weekday(2);
      return day.add(this.get('currentWeek'), 'weeks');
    },
    fourthDay() {
      const day = moment(this.get('currentDate')).weekday(3);
      return day.add(this.get('currentWeek'), 'weeks');
    },
    fifthDay() {
      const day = moment(this.get('currentDate')).weekday(4);
      return day.add(this.get('currentWeek'), 'weeks');
    },
    sixthDay() {
      const day = moment(this.get('currentDate')).weekday(5);
      return day.add(this.get('currentWeek'), 'weeks');
    },
    seventhDay() {
      const day = moment(this.get('currentDate')).weekday(6);
      return day.add(this.get('currentWeek'), 'weeks');
    },
    lastDay() {
      const day = this.get('firstDay');
      return day.add(1, 'week');
    }
  },
  initialize() {
    this.updateTime();

    if (!interval) {
      interval = setInterval(_(this.updateTime).bind(this), 1000);
    }

    this.set('currentWeek', 0);
  },
  goToPrevWeek() {
    this.set('currentWeek', this.get('currentWeek') - 1);
  },
  goToNextWeek() {
    this.set('currentWeek', this.get('currentWeek') + 1);
  },
  updateTime() {
    const currentDate = moment(moment().format('YYYY-MM-DD HH:mm'));

    this.set('currentDate', currentDate.toDate());
  }
});

module.exports = new TimeModel();



// WEBPACK FOOTER //
// ./src/data/time.js